import { render, staticRenderFns } from "./SingleFileUploadOSS.vue?vue&type=template&id=1d5f9f1a&scoped=true&"
import script from "./SingleFileUploadOSS.vue?vue&type=script&lang=ts&"
export * from "./SingleFileUploadOSS.vue?vue&type=script&lang=ts&"
import style0 from "./SingleFileUploadOSS.vue?vue&type=style&index=0&id=1d5f9f1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f9f1a",
  null
  
)

export default component.exports